<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputText" });
import Input from "../input/Input.svelte";
export let value;
export let name;
export let label = void 0;
export let hint = void 0;
export let placeholder = void 0;
export let isDisabled = false;
export let isReadonly = false;
export let isRequired = true;
export let minLength = void 0;
export let maxLength = void 0;
export let pattern = void 0;
export let autocomplete = "on";
export let keyboard = "text";
const getHint = (hint2, minLength2, maxLength2) => {
    const HAS_MIN_LENGTH = minLength2 !== void 0 && minLength2 > 3;
    const HAS_MAX_LENGTH = maxLength2 !== void 0;
    if (hint2 !== void 0) {
        return hint2;
    }
    if (HAS_MIN_LENGTH && HAS_MAX_LENGTH) {
        return `between ${minLength2} and ${maxLength2} characters`;
    }
    if (HAS_MIN_LENGTH) {
        return `min ${minLength2} characters`;
    }
    if (HAS_MAX_LENGTH) {
        return `max ${maxLength2} characters`;
    }
    return void 0;
};
$: defaultHint = getHint(hint, minLength, maxLength);
let inputComponent;
export const focus = () => {
    inputComponent.focus();
};
</script>

<Input
    bind:value
    bind:this = { inputComponent }
    on:blur
    on:keydown
    type = 'text'
    hint = { defaultHint }
    { maxLength }
    { minLength }
    { autocomplete }
    { keyboard }
    { label }
    { name }
    { isDisabled }
    { isReadonly }
    { isRequired }
    { pattern }
    { placeholder }
>
    <svelte:fragment slot = 'beforeInput'><slot name = 'beforeInput' /></svelte:fragment>
    <svelte:fragment slot = 'afterInput'><slot name = 'afterInput' /></svelte:fragment>
</Input>